import { render, staticRenderFns } from "./k-diff-pill.vue?vue&type=template&id=0e20edf7&scoped=true"
import script from "./k-diff-pill.vue?vue&type=script&lang=js"
export * from "./k-diff-pill.vue?vue&type=script&lang=js"
import style0 from "./k-diff-pill.vue?vue&type=style&index=0&id=0e20edf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20edf7",
  null
  
)

export default component.exports